import { useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { Modal } from 'react-bootstrap';
import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { themes } from '@/constants/colors_v2';
import { addCurrentThemeClassToEle } from '@/utils';

function WatchModle2(props: any) {
    const { timeline, common } = useLocalTranslation();
    const [date, setDate] = useState('');
    const [dateErr, setDateErr] = useState(false);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    // const [step, setStep] = useState(0)

    const today = new Date().toLocaleDateString('en-CA');
    const setCourseStartDateHelper = () => {
        if (date === '') {
            setDateErr(true)
            return
        }
        props.setCourseStartDate(date)
        // setStep(step + 1)
    }

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose()} centered>
            <div
                className={` 
                    ${props.stepForModal2 === 1 ? 'bg-[#EEFFE1] ' : ''}
                p-[20px] 
                ${addCurrentThemeClassToEle(currentTheme, 'watchModle1Index')}`}>

                <Modal.Header
                    className={` ${props.stepForModal2 === 0 ? 'mb-[10px]' : ''} p-0 border-0`}>


                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.stepForModal2 === 1 &&
                                     <p>{timeline.watchSection.popUp2.p3}</p>
                                }
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose()}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.stepForModal2 === 1 &&
                                     <p>{timeline.watchSection.popUp2.p3}</p>
                                }
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose()}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}


                    {/* {props.stepForModal2 === 1 &&
                        <Modal.Title className='text-[15px] font-semibold text-[#397D05]'>
                            <p>{timeline.watchSection.popUp2.p3}</p>
                        </Modal.Title>
                    }
                    <button
                        onClick={() => props.handleClose()}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button> */}


                </Modal.Header>

                <Modal.Body className='p-0'>
                    {props.stepForModal2 === 0 &&
                        <>

                            <p className='mb-[13px]'>{timeline.watchSection.popUp2.p1}</p>

                            {dateErr &&
                                <p className='text-red-600 mb-[4px]'>{timeline.watchSection.dateErr}</p>
                            }
                            <div className="mb-4">
                                <input
                                    type="date"
                                    value={date}
                                    min={today}
                                    onChange={(e) => { setDate(e.target.value); setDateErr(false) }}
                                    className="w-full watchModel12InputDate px-2 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            <p className='mb-[12px]'>{timeline.watchSection.popUp2.p2}</p>
                            <div className='flex gap-[10px]'>
                                <button
                                    onClick={() => props.handleClose()}
                                    className={`w-1/2 cursor-pointer watchModel12LeftBtn py-[7px] rounded-[5px] text-[14px]`}>
                                    {common.statusText.cancleBtn}
                                </button>

                                <button
                                    onClick={() => setCourseStartDateHelper()}
                                    className='w-1/2 cursor-pointer bg-[#1573FE] py-[7px] text-white rounded-[5px] text-[14px]'>
                                    {common.statusText.setBtn}
                                </button>
                            </div>
                        </>
                    }
                </Modal.Body>

            </div>
        </Modal>
    );
}

export default WatchModle2;